<div [formGroup]="contractForm" fxLayout="row wrap" fxLayoutAlign="space-between">
  <div *ngIf="generalError" class="mat-error">
    {{generalError?.message}}
  </div>

  <div fxFlex="45" fxLayout="column" class="mb-2_5" fxLayoutGap="3%" *awIsInRoleAndStatusForThisEntity="[
       {permission: 'admin', status: undefined, entity: _contract},
       {permission: 'customer', status: undefined, entity: _contract},
     ]">
    <mat-label id="radio-group">Select contract type: </mat-label>

    <mat-radio-group fxFlexOffset="2" fxLayoutGap="1%" fxLayout="column" aria-labelledby="radio-group"
      (change)="setContractType($event)" [formControlName]="'contractType'">
      <mat-radio-button [checked]="contractType === contractTypes.directContract"
        [value]="contractTypes.directContract">
        DIRECT CONTRACT
      </mat-radio-button>
      <mat-radio-button [checked]="contractType === contractTypes.partnership" [value]="contractTypes.partnership">
        PARTNERSHIP
      </mat-radio-button>
    </mat-radio-group>

    <section>
      <mat-checkbox (change)="setTestbedReferentFieldsValidators()" [formControlName]="'isSameReferent'">Contract
        referent is also testbed referent *</mat-checkbox>
    </section>
  </div>

  <div class="border border-primary disclaimer-box mat-background-light p-2_5 mb-2_5" fxFlex="45"
    *awIsInRoleAndStatusForThisEntity="[
       {permission: 'admin', status: undefined, entity: _contract},
       {permission: 'customer', status: undefined, entity: _contract},
     ]">
    <small *ngIf="contractType === contractTypes.directContract">
      Direct contract describes an agreement between Drivesec and a company that is the final client and generally owns
      the testbed.
    </small>
    <small *ngIf="contractType === contractTypes.partnership">
      Partnership contract describes an agreement between Drivesec and a company that works for a third party client,
      generally the company does not own the testbed.
    </small>
  </div>

  <ng-container *awIsInRoleAndStatusForThisEntity="[
           {permission: 'admin', status: undefined, entity: _contract}]">
    <mat-form-field fxFlex="45">
      <mat-label>Company </mat-label>
      <mat-select (selectionChange)="onCompanyChange()" [(value)]="selectedCompany" formControlName="company" name="company">
        <mat-option *ngIf="!loadingCompanies && companies.length === 0">
          No companies available.
        </mat-option>
        <mat-option *ngFor="let company of companies" [value]="company">
          {{company.companyName}}
        </mat-option>
      </mat-select>
      <span *ngIf="loadingCompanies" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
      <mat-error *ngIf="contractForm.controls.company?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
      <mat-hint *ngIf="!loadingCompanies && companies.length === 0" class="color-warn">
        No companies available
      </mat-hint>
    </mat-form-field>
  </ng-container>

  <mat-form-field *awIsInRoleAndStatusForThisEntity="[
       {permission: 'admin', status: undefined, entity: _contract},
       {permission: 'customer', status: undefined, entity: _contract},
       {permission: 'admin', status: contractStatuses.new, entity: _contract},
       {permission: 'customer', status: contractStatuses.new, entity: _contract},
     ]" fxFlex="45">
    <mat-label>Title </mat-label>
    <input formControlName="title" matInput name="title" type="text">
    <mat-error *ngIf="contractForm.controls.title?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field *awIsInRoleAndStatusForThisEntity="[
     {permission: 'admin', status: undefined, entity: _contract},
     {permission: 'customer', status: undefined, entity: _contract},
     {permission: 'admin', status: contractStatuses.new, entity: _contract},
     {permission: 'customer', status: contractStatuses.new, entity: _contract},
   ]" fxFlex="45">
    <mat-label>Description </mat-label>
    <input formControlName="description" matInput name="description" type="text">
    <mat-error *ngIf="contractForm.controls.description?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <ng-container *awIsInRoleAndStatusForThisEntity="[
       {permission: 'admin', status: undefined, entity: _contract},
     ]">
    <div fxFlex="45" fxLayout="column" fxLayoutAlign="start">
      <mat-form-field fxFlex>
        <mat-label>Referent </mat-label>
        <mat-select [(value)]="selectedCustomer" formControlName="contractReferent" name="contractReferent"
          [disabled]="!adminHasSelectedCompany">
          <mat-option *ngIf="!loadingCustomers && customers.length === 0">
            No referents available
          </mat-option>
          <mat-option *ngFor="let referent of customers" [value]="referent">
            {{referent.email}}
          </mat-option>
        </mat-select>
        <span *ngIf="loadingCustomers" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
        <mat-error *ngIf="contractForm.controls.contractReferent?.errors?.required">
          Field <strong>required</strong>
        </mat-error>
        <mat-hint *ngIf="!loadingCustomers && customers.length === 0" class="color-warn">
          No referents available
        </mat-hint>
      </mat-form-field>
    </div>
  </ng-container>

  <mat-form-field *awIsInRoleAndStatusForThisEntity="[
     {permission: 'admin', status: undefined, entity: _contract},
     {permission: 'customer', status: undefined, entity: _contract},
     {permission: 'admin', status: contractStatuses.new, entity: _contract},
     {permission: 'customer', status: contractStatuses.new, entity: _contract},
   ]" fxFlex="45">

    <mat-label>Start Date </mat-label>
    <input formControlName="startDate" readonly matInput name="startDate" [matDatepicker]="startDate"
      (focusin)="startDate.open()" [max]="getSixMonthsBeforeEndDate()">
    <mat-datepicker-toggle [for]="startDate" matSuffix></mat-datepicker-toggle>
    <mat-datepicker-toggle matSuffix (click)="contractForm.controls.startDate.setValue(null)">
      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #startDate></mat-datepicker>
    <mat-error
      *ngIf="contractForm.controls.startDate?.errors?.pattern && !contractForm.controls.startDate?.errors?.required">
      Please enter a valid date
    </mat-error>
    <mat-error *ngIf="contractForm.controls.startDate?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field *awIsInRoleAndStatusForThisEntity="[
     {permission: 'admin', status: undefined, entity: _contract},
     {permission: 'customer', status: undefined, entity: _contract},
     {permission: 'admin', status: contractStatuses.new, entity: _contract},
     {permission: 'customer', status: contractStatuses.new, entity: _contract},
   ]" fxFlex="45">
    <mat-label>End Date </mat-label>

    <input formControlName="endDate" readonly matInput name="endDate" [matDatepicker]="endDate"
      (focusin)="endDate.open()" [min]="getSixMonthsAfterStartDate()">
    <mat-datepicker-toggle [for]="endDate" matSuffix></mat-datepicker-toggle>
    <mat-datepicker-toggle matSuffix (click)="contractForm.controls.endDate.setValue(null)">
      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #endDate></mat-datepicker>
    <mat-error *ngIf="contractForm.controls.endDate?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
    <mat-error
      *ngIf="contractForm.controls.endDate?.errors?.pattern && !contractForm.controls.endDate?.errors?.required">
      Please enter a valid date
    </mat-error>
  </mat-form-field>

  <mat-form-field *awIsInRoleAndStatusForThisEntity="[
     {permission: 'customer', status: contractStatuses.ongoing, entity: _contract},
     {permission: 'admin', status: contractStatuses.ongoing, entity: _contract},
     {permission: 'customer', status: contractStatuses.extended, entity: _contract},
     {permission: 'admin', status: contractStatuses.extended, entity: _contract}
   ]" fxFlex="45">
    <mat-label>Extended End Date</mat-label>

    <input formControlName="extendedEndDate" readonly matInput name="extendedEndDate"
      [matDatepicker]="extendedEndDatePicker" (focusin)="extendedEndDatePicker.open()" [min]="minDate">
    <mat-datepicker-toggle [for]="extendedEndDatePicker" matSuffix></mat-datepicker-toggle>
    <mat-datepicker-toggle matSuffix (click)="contractForm.controls.extendedEndDate.setValue(null)">
      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
    </mat-datepicker-toggle>
    <mat-datepicker #extendedEndDatePicker></mat-datepicker>

    <mat-error
      *ngIf="contractForm.controls.extendedEndDate?.errors?.pattern && !contractForm.controls.extendedEndDate?.errors?.required">
      Please enter a valid date
    </mat-error>
  </mat-form-field>

  <mat-form-field *awIsInRoleAndStatusForThisEntity="[
     {permission: 'admin', status: undefined, entity: _contract},
     {permission: 'customer', status: undefined, entity: _contract},
     {permission: 'admin', status: contractStatuses.new, entity: _contract},
     {permission: 'customer', status: contractStatuses.new, entity: _contract},
   ]" fxFlex="45">
    <mat-label>Note</mat-label>
    <input formControlName="note" matInput name="note" type="text">
  </mat-form-field>

  <mat-form-field *awIsInRoleAndStatusForThisEntity="[
     {permission: 'admin', status: undefined, entity: _contract},
     {permission: 'customer', status: undefined, entity: _contract},
     {permission: 'admin', status: contractStatuses.new, entity: _contract},
     {permission: 'customer', status: contractStatuses.new, entity: _contract},
   ]" fxFlex="45" [fxHide]="contractType === contractTypes.directContract">
    <mat-label>Third Party Contract </mat-label>
    <input formControlName="thirdPartyContract" matInput [min]="general.minimumThirdPartyContractValue"
      [max]="general.maximumThirdPartyContractValue" name="thirdPartyContract" type="number">
    <span matPrefix>€&nbsp;</span>
    <mat-error *ngIf="contractForm.controls.thirdPartyContract?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
    <mat-error *ngIf="contractForm.controls.thirdPartyContract?.errors?.min">
      Field can't be <strong>less than {{contractForm.controls.thirdPartyContract?.errors?.min.min}}</strong>
    </mat-error>
    <mat-error *ngIf="contractForm.controls.thirdPartyContract?.errors?.max">
      Field can't be <strong>more than {{contractForm.controls.thirdPartyContract?.errors?.max.max}}</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field *awIsInRoleAndStatusForThisEntity="[
     {permission: 'admin', status: undefined, entity: _contract},
     {permission: 'customer', status: undefined, entity: _contract},
     {permission: 'admin', status: contractStatuses.new, entity: _contract},
     {permission: 'customer', status: contractStatuses.new, entity: _contract},
   ]" fxFlex="45">
    <mat-label>Number Of Boxes </mat-label>
    <input formControlName="numberOfBoxes" matInput [min]="general.minimumNumberOfBoxesValue"
      [max]="general.maximumNumberOfBoxesValue" name="numberOfBoxes" type="number">
    <mat-error *ngIf="contractForm.controls.numberOfBoxes?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
    <mat-error *ngIf="contractForm.controls.numberOfBoxes?.errors?.min">
      Field can't be <strong>less than {{contractForm.controls.numberOfBoxes?.errors?.min.min}}</strong>
    </mat-error>
    <mat-error *ngIf="contractForm.controls.numberOfBoxes?.errors?.max">
      Field can't be <strong>more than {{contractForm.controls.numberOfBoxes?.errors?.max.max}}</strong>
    </mat-error>
  </mat-form-field>

  <ng-container *awIsInRoleAndStatusForThisEntity="[
       {permission: 'admin', status: undefined, entity: _contract},
       {permission: 'customer', status: undefined, entity: _contract},
       {permission: 'admin', status: contractStatuses.new, entity: _contract},
       {permission: 'customer', status: contractStatuses.new, entity: _contract},
       {permission: 'customer', status: contractStatuses.testbedAssociation, entity: _contract}
     ]">
    <div fxFlex="45" fxLayout="column" fxLayoutAlign="start">
      <mat-form-field fxFlex>
        <mat-label>Testbed </mat-label>
        <mat-select [(value)]="selectedTestbed" formControlName="testbed" name="testbed">
          <mat-option *ngIf="!loadingTestbeds && filteredTestbeds.length === 0">
            No testbeds available
          </mat-option>
          <mat-option *ngFor="let testbed of filteredTestbeds" [value]="testbed">
            {{testbed.identifier}} of {{testbed.company?.companyName}} in {{testbed.address}}
          </mat-option>
        </mat-select>
        <span *ngIf="loadingTestbeds" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
        <button (click)="$event.stopPropagation();openTestbedForm()" class="z-front" color="primary" mat-button
          matSuffix
          [disabled]="!contractForm.controls['company'].value">
          New
        </button>
        <mat-hint *ngIf="!loadingTestbeds && filteredTestbeds.length === 0" class="color-warn">
          No testbeds available
        </mat-hint>
      </mat-form-field>
    </div>
  </ng-container>


  <mat-form-field *awIsInRoleAndStatusForThisEntity="[
       {permission: 'admin', status: undefined, entity: _contract},
       {permission: 'customer', status: undefined, entity: _contract},
     ]" fxFlex="45" [fxHide]="testbedReferentFieldsHidden">
    <mat-label>Testbed's referent first name </mat-label>
    <input formControlName="testbedReferentFirstName" matInput name="testbedReferentFirstName" type="text">
    <mat-error *ngIf="contractForm.controls.testbedReferentFirstName?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>


  <mat-form-field *awIsInRoleAndStatusForThisEntity="[
       {permission: 'admin', status: undefined, entity: _contract},
       {permission: 'customer', status: undefined, entity: _contract},
   ]" fxFlex="45" [fxHide]="testbedReferentFieldsHidden">
    <mat-label>Testbed's referent last name </mat-label>
    <input formControlName="testbedReferentLastName" matInput name="testbedReferentLastName" type="text">
    <mat-error *ngIf="contractForm.controls.testbedReferentLastName?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field *awIsInRoleAndStatusForThisEntity="[
       {permission: 'admin', status: undefined, entity: _contract},
       {permission: 'customer', status: undefined, entity: _contract},
     ]" fxFlex="45" [fxHide]="testbedReferentFieldsHidden">
    <mat-label>Testbed's referent email </mat-label>
    <input formControlName="testbedReferentEmail" matInput name="testbedReferentEmail" type="email">
    <mat-error *ngIf="contractForm.controls.email?.errors?.pattern && !contractForm.controls.email?.errors?.required">
      Please enter a valid email address
    </mat-error>
    <mat-error *ngIf="contractForm.controls.testbedReferentEmail?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field *awIsInRoleAndStatusForThisEntity="[
       {permission: 'admin', status: undefined, entity: _contract},
       {permission: 'customer', status: undefined, entity: _contract},
     ]" fxFlex="45" [fxHide]="testbedReferentFieldsHidden">
    <mat-label>Testbed's referent phone number </mat-label>

    <input formControlName="testbedReferentPhoneNumber" matInput type="tel" name="testbedReferentPhoneNumber"
      [mask]="'+00 000 0*'" [dropSpecialCharacters]="false">
    <mat-error
      *ngIf="(contractForm.controls.testbedReferentPhoneNumber?.errors?.pattern || contractForm.controls.phone?.errors?.mask) && !contractForm.controls.testbedReferentPhoneNumber?.errors?.required">
      Please enter a valid phone number
    </mat-error>
    <mat-error *ngIf="contractForm.controls.testbedReferentPhoneNumber?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <div fxFlex="100" fxLayout="row" fxLayoutAlign="end">
    <button (click)="contract = _contract; canceled.emit()" mat-button>Cancel</button>
    <button (click)="saveContract()" [disabled]="contractForm.invalid || saving" color="primary" mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</div>
